import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { ModalProvider } from "./context/ModalContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import TrustSection from "./components/TrustSection";
import CaseStudies from "./components/CaseStudies";
import Careers from "./components/Careers";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";
import Testimonials from "./components/Testimonials";
import Lab from "./components/Lab";
import Consulting from "./components/Consulting";
import AutomationPage from "./components/AutomationPage";
import AgentDevelopmentPage from "./components/AgentDevelopmentPage";
import ProductDevelopmentPage from "./components/ProductDevelopmentPage";
import VoiceAIPage from "./components/VoiceAIPage";
import KnowledgeRagPage from "./components/KnowledgeRagPage";
import AIInfrastructurePage from "./components/AIInfrastructurePage";
import CaseStudyOneHive from "./components/CaseStudyOneHive";
import CaseStudyOncology from "./components/CaseStudyOncology";
import CaseStudyFintech from "./components/CaseStudyFintech";
import CaseStudyLawFirm from "./components/CaseStudyLawFirm";
import Footer from "./components/Footer";
import DemoModal from "./components/DemoModal";
import Solutions from "./components/Solutions";
import SolutionDetail from "./components/SolutionDetail";
import { DotPattern } from "./components/ui/dot-pattern";
import { useModal } from "./context/ModalContext";

const SiteLayout = ({ children, sidePatternTop = "0px" }) => {
  const { isDemoModalOpen, closeDemoModal } = useModal();

  return (
    <div className="relative bg-[--bg-primary] min-h-screen transition-colors duration-300 overflow-hidden">
      <div
        className="pointer-events-none fixed left-0 right-0 bottom-0 z-[12]"
        style={{ top: sidePatternTop }}
      >
        <div className="site-dot-side site-dot-side--left hidden lg:block">
          <DotPattern className="site-dot-pattern" />
        </div>
        <div className="site-dot-side site-dot-side--right hidden lg:block">
          <DotPattern className="site-dot-pattern" />
        </div>
      </div>

      <div className="relative z-10">
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
      
      {/* Demo Modal */}
      <DemoModal isOpen={isDemoModalOpen} onClose={closeDemoModal} />
    </div>
  );
};

const LandingPageContent = () => {
  return (
    <SiteLayout sidePatternTop="100vh">
      <Hero />
      <Services />
      <HowItWorks />
      <TrustSection />
      <CaseStudies />
      <Testimonials />
      <FAQ />
      <CTA />
    </SiteLayout>
  );
};

const CareersPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <Careers showViewAll={false} />
      </div>
    </SiteLayout>
  );
};

const SolutionsPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <Solutions />
      </div>
    </SiteLayout>
  );
};

const LabPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <Lab />
      </div>
    </SiteLayout>
  );
};

const ConsultingPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <Consulting />
      </div>
    </SiteLayout>
  );
};

const AutomationPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <AutomationPage />
      </div>
    </SiteLayout>
  );
};

const AgentDevelopmentPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <AgentDevelopmentPage />
      </div>
    </SiteLayout>
  );
};

const ProductDevelopmentPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <ProductDevelopmentPage />
      </div>
    </SiteLayout>
  );
};

const VoiceAIPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <VoiceAIPage />
      </div>
    </SiteLayout>
  );
};

const KnowledgeRagPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <KnowledgeRagPage />
      </div>
    </SiteLayout>
  );
};

const AIInfrastructurePageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <AIInfrastructurePage />
      </div>
    </SiteLayout>
  );
};

const CaseStudyOneHiveContent = () => (
  <SiteLayout>
    <div className="pt-16 md:pt-[72px]">
      <CaseStudyOneHive />
    </div>
  </SiteLayout>
);

const CaseStudyOncologyContent = () => (
  <SiteLayout>
    <div className="pt-16 md:pt-[72px]">
      <CaseStudyOncology />
    </div>
  </SiteLayout>
);

const CaseStudyFintechContent = () => (
  <SiteLayout>
    <div className="pt-16 md:pt-[72px]">
      <CaseStudyFintech />
    </div>
  </SiteLayout>
);

const CaseStudyLawFirmContent = () => (
  <SiteLayout>
    <div className="pt-16 md:pt-[72px]">
      <CaseStudyLawFirm />
    </div>
  </SiteLayout>
);

const SolutionDetailPageContent = () => {
  return (
    <SiteLayout>
      <div className="pt-16 md:pt-[72px]">
        <SolutionDetail />
      </div>
    </SiteLayout>
  );
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ModalProvider>
          <Routes>
            <Route path="/" element={<LandingPageContent />} />
            <Route path="/careers" element={<CareersPageContent />} />
            <Route path="/solutions" element={<SolutionsPageContent />} />
            <Route path="/lab" element={<LabPageContent />} />
            <Route path="/consulting" element={<ConsultingPageContent />} />
            <Route path="/automation" element={<AutomationPageContent />} />
            <Route path="/agent-development" element={<AgentDevelopmentPageContent />} />
            <Route path="/product-development" element={<ProductDevelopmentPageContent />} />
            <Route path="/voice-ai" element={<VoiceAIPageContent />} />
            <Route path="/knowledge-rag" element={<KnowledgeRagPageContent />} />
            <Route path="/ai-infrastructure" element={<AIInfrastructurePageContent />} />
            <Route path="/case-studies/onehive-healthcare" element={<CaseStudyOneHiveContent />} />
            <Route path="/case-studies/oncology-prior-auth" element={<CaseStudyOncologyContent />} />
            <Route path="/case-studies/fintech-fraud-detection" element={<CaseStudyFintechContent />} />
            <Route path="/case-studies/law-firm-contract-intelligence" element={<CaseStudyLawFirmContent />} />
            <Route path="/solutions/:solutionSlug" element={<SolutionDetailPageContent />} />
          </Routes>
        </ModalProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
